import { AuthorisedUser, TradingEntity } from 'api'
import { isNotNil } from 'utils/predicate'

const getCounterpartyIdsFromGroup = (counterpartyName: string, authorisedUser: AuthorisedUser) =>
  authorisedUser.userPreference.counterpartyGroups.find(counterpartyGroup => counterpartyGroup.description === counterpartyName)
    ?.counterpartyIds

const getCounterpartyNamesById = (counterpartyIdsFromGroup: string[], allActiveTradingEntities: TradingEntity[]) =>
  counterpartyIdsFromGroup
    .map(counterpartyId => allActiveTradingEntities.find(activeTradingEntity => activeTradingEntity.id === counterpartyId)?.publishedName)
    .filter(isNotNil)

export const getCounterpartyNamesFromGroups = (
  groupAndCounterpartyNamesFromSpreadsheet: string[],
  groupNames: string[],
  authorisedUser: AuthorisedUser,
  allActiveTradingEntities: TradingEntity[]
) =>
  groupAndCounterpartyNamesFromSpreadsheet.reduce((acc, cur) => {
    const counterpartyName = cur.trim()
    if (!groupNames.includes(counterpartyName)) {
      return acc
    }
    const counterpartyIdsFromGroup = getCounterpartyIdsFromGroup(counterpartyName, authorisedUser)
    const counterpartyNamesFromGroups = counterpartyIdsFromGroup
      ? getCounterpartyNamesById(counterpartyIdsFromGroup, allActiveTradingEntities)
      : []
    return [...acc, ...counterpartyNamesFromGroups]
  }, [])

export const getOnlyCounterpartyNames = (groupAndCounterpartyNamesFromSpreadsheet: string[], groupNames: string[]) =>
  groupAndCounterpartyNamesFromSpreadsheet.filter(spreadsheetName => !groupNames.includes(spreadsheetName.trim()))
